import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CategoryEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const [category, setCategory] = useState({
    name: "",
    description: "",
  });
  const [error, setError] = useState(null);

  // Fetch category by ID
  const fetchCategoryById = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/category/list/${id}`,
        { headers: { token } }
      );
      if (response.data.success) {
        setCategory({
          name: response.data.categories.name || "",
          description: response.data.categories.description || "",
        });
      } else {
        toast.error("Failed to load category.");
      }
    } catch (err) {
      setError("Error fetching category.");
      console.error(err);
    }
  };

  useEffect(() => {
    if (id) fetchCategoryById(id);
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!category.name.trim()) {
      toast.error("Category name is required.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/category/update/${id}`,
        category,
        { headers: { token } }
      );

      if (response.data.success) {
        toast.success("Category updated successfully!");
      } else {
        toast.error(response.data.message || "Failed to update category.");
      }
    } catch (err) {
      toast.error("Error updating category.");
      console.error(err);
    }
  };

  return (
    <div className="container mt-5">
      <ToastContainer />
      <button
        className="btn btn-outline-primary mb-3"
        onClick={() => navigate("/category-management/index")}
      >
        <i className="fa fa-arrow-left me-2"></i>Back to Category List
      </button>

      <form onSubmit={handleSubmit} className="border p-4 rounded shadow-sm bg-light">
        <h3 className="text-center mb-4">Edit Category</h3>

        {/* Name */}
        <div className="form-group mb-3">
          <label className="required-field">Category Name</label>
          <input
            type="text"
            name="name"
            required
            value={category.name}
            onChange={handleChange}
            className="form-control"
            placeholder="Enter category name"
          />
        </div>

        {/* Description */}
        <div className="form-group mb-3">
          <label>Description</label>
          <textarea
            name="description"
            value={category.description}
            onChange={handleChange}
            className="form-control"
            rows="4"
            placeholder="Enter description (optional)"
          />
        </div>

        <div className="text-center">
          <button type="submit" className="btn btn-primary px-4">
            Update Category
          </button>
        </div>
      </form>

      {error && <div className="alert alert-danger mt-3">{error}</div>}
    </div>
  );
};

export default CategoryEdit;
